module.exports = __webpack_public_path__ + "img/class2.da7db6db.webp";